import {IStickersShowState} from "./reducer";

export const stickerShowStateSelector = (state: any): IStickersShowState => {
    return state.stickers.showLlama;
}

export const stickerShowCongratulationSelector = (state: any): boolean => {
    return stickerShowStateSelector(state).showCongratulation
}

export const isMemorialType = (state: any): boolean => {
    const id = state.stickers.entities.stickers.ids[0];
    return state.stickers.entities.stickers.byId[id]?.type === 'MEMORIAL';
};


// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/sticker-show/selectors.ts